export const VIEW_ASSESSMENT: string = 'viewassessment';
export const REVIEW_ASSESSMENT: string = 'reviewassessment';
export const VIEW: string = 'view';
export const REVIEW: string = 'review';
export const REJECT: string = 'Reject';
export const ASSTMT_REJECTION_REASON_ID: number = 7;
export const APPROVE: string = 'Approve';
export const REQUEST_EXTENSION: string = 'Request for Extension';
export const REASON_FOR_EXTENSION_OTHER: number = 6;
export const PATH_DATA_INDEX: number = 1;
export const GOALS_NOT_APPROPRIATE: number = 1;
export const EVALUATIONS_STATUS: number = 1;
export const REVIEW_REQUEST_FOR_EXTENSION: string =
  'Review Request for Extension';
export const OTHER_REASON_ID: string = 'Other';
export const ACTION_TYPE_APPROVED: number = 3;
export const ACTION_TYPE_FINALIZED: number = 7;
export const ACTION_TYPE_REJECTED: number = 4;
export const ACTION_TYPE_REQUESTED: number = 5;
export const EXTENSION_DATA_REJECTED_STATUS: number = 8;
export const EXTENSION_DATA_NOT_SUBMITTED_STATUS: number = 2;
export const EXTENSION_DATA_CLOSED_STATUS: number = 7;
export const EXTENSION_DATA_ACCEPTED_STATUS: number = 6;
